import { render } from "./RichEditor.vue?vue&type=template&id=6d48e191"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"

import "./RichEditor.vue?vue&type=style&index=0&id=6d48e191&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__